/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import './dep-34428f12.mjs';

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}
var _arrayPush = arrayPush;

export { _arrayPush as _ };
//# sourceMappingURL=dep-0f45a6e0.mjs.map
